import { type APIConfig } from '../apiTypes'
import { axiosInstance } from './axiosInstance'

const axios = axiosInstance()

type Response = any

export const getCheckoutcart = async <T = any>(args: {
  apiConfigs: APIConfig
  onSuccess: (checkoutcart: { data: Response }) => T
}): Promise<T> => {
  const { onSuccess } = args
  const { scensumBaseUrl } = args.apiConfigs

  return await axios({
    method: 'get',
    url: `${scensumBaseUrl}/cart/getcheckoutcart`,
  })
    .then((response) => onSuccess(response))
    .catch((error) => {
      console.error(error)
      throw new Error(JSON.stringify(error))
    })
}
